import React, { Fragment, useState, useEffect, useRef } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import AttachmentIcon from "@material-ui/icons/Attachment";
import LinkIcon from "@material-ui/icons/Link";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { useSnackbar } from "notistack";
import { regexConstants } from "../../../../constants/regEx";
import { backendDateFormat, dayMonthDateFormat, fieldDMYShort, assetType, imgStoragePath } from "../../../../constants";
import { checkApiStatus, permissionCheckFnforCamo } from "../../../../utils";
import { globalGetService, globalPostService, globalPutService, globalDeleteService, globalFileUploadService } from "../../../../utils/globalApiServices";
import { trackActivity } from "../../../../utils/mixpanel";
import LinkFiles from "../../../../shared_elements/components/LinkFiles";
import UploadFile from "../../../../shared_elements/components/UploadFile";
import { PageLoader, DeletePopUp } from "../../../../shared_elements";
import { acumenCamo } from "../../../../shared_elements/components";
import config from "../../../../config";

const formValues = {
	MPD_item_no: null,
	task_card_no: null,
	previous_LDND_Taskcard: null,
	Task_Description: null,
	threshold_D: null, threshold_FH: null, threshold_FC: null,
	interval_D: null, interval_FH: null, interval_FC: null,
	lastDone_D: null, lastDone_FH: null, lastDone_FC: null,
	remainingValues_D: null, remainingValues_FH: null, remainingValues_FC: null,
	remarks: null, workOrder: null,
	nextDue_D: null, nextDue_FH: null, nextDue_FC: null,
	checklist: [], folder_uuid: null,
};

const AmpTaskForm = ({ match, modeType, ampData, modalCloseFn, getResponseBack, headerTsn, headerCsn, date_of_manufacture, uuid, last_used_folder_uuid, last_used_folder_uuid_link_document, checkbox_last_used_folder_uuid, checkbox_last_used_folder_name, }) => {
	const { enqueueSnackbar } = useSnackbar();
	const [error, setError] = useState({});
	const [data, setData] = useState(formValues);
	const [attachments, setAttachments] = useState([]);
	const [newUploadedAttachments, setNewUploadedAttachments] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [deleteAttachModal, setDeleteAttachModal] = useState({ open: false, id: null, attachment: null });
	const [linkFile, setLinkFile] = useState(false);
	const [uploadFile, setUploadFile] = useState(false);
	const addAnotherRef = useRef(false);
	const dataRef = useRef(data);
	const newUploadedAttachmentsRef = useRef(newUploadedAttachments);
	dataRef.current = data;
	newUploadedAttachmentsRef.current = newUploadedAttachments;

	useEffect(() => {
		trackActivity('AMP Add Modal Opened - CAMO', {
			event_type: 'Modal Opened',
			page_title: 'AMP Add Task Form',
		});
		if (modeType === 'edit' && ampData?.id) {
			setIsLoading(true);
			globalGetService(`camo/amp/view/${ampData.id}/`).then((response) => {
				setIsLoading(false);
				if (checkApiStatus(response)) {
					setData(response.data.data);
					setAttachments(response.data.data.attachments || []);
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
		}
	}, []);

	const onFieldChange = (key, value) => setData(prev => ({ ...prev, [key]: value }));
	const onRestErrorKey = (key) => setError(prev => ({ ...prev, [key]: "" }));

	const validate = () => ({
		MPD_item_no: data?.MPD_item_no?.trim() ? "" : "Please enter MPD item no",
		task_card_no: (acumenCamo || data?.task_card_no?.trim()) ? "" : "Please enter task card no",
		Task_Description: (acumenCamo || data?.Task_Description?.trim()) ? "" : "Please enter task description",
		threshold_D: (acumenCamo || data.threshold_FH || data.threshold_FC || data?.threshold_D?.trim()) ? "" : "Please enter Days",
		interval_FH: (acumenCamo || data.threshold_FH || data?.interval_FH?.trim()) ? "" : "Please enter FH",
		interval_FC: (acumenCamo || data.threshold_FC || data?.interval_FC?.trim()) ? "" : "Please enter FC",
		interval_D: (acumenCamo || data.threshold_D || data?.interval_D?.trim()) ? "" : "Please enter interval D",
		lastDone_D: (acumenCamo || data?.lastDone_D) ? "" : "Please enter last done D",
		lastDone_FH: (acumenCamo || data.lastDone_FH) ? "" : "Please enter last done FH",
		lastDone_FC: (acumenCamo || data.lastDone_FC) ? "" : "Please enter last done FC",
	});

	const uploadFiles = async (id) => {
		const files = newUploadedAttachmentsRef.current;
		if (!files.length) return;
		const formdata = new FormData();
		files.forEach((file, key) => {
			formdata.append(`[${key}]file`, file);
			formdata.append(`[${key}]file_type`, file.type);
			formdata.append(`[${key}]file_name`, file.name);
			formdata.append(`[${key}]module_id`, id);
			formdata.append(`[${key}]module_type_id`, 1);
			formdata.append(`[${key}]asset_id`, match.params.asset);
			formdata.append(`[${key}]asset_type_id`, match.params.assetType);
		});
		return globalFileUploadService('camo/attachment/upload/', formdata);
	};

	const submitFileLinks = async (id) => {
		const currentData = dataRef.current;
		const checklist = currentData.checklist || [];
		const linkedItems = checklist.filter(item => item.id);
		if (linkedItems.length > 0) {
			const payload = {};
			const folders = linkedItems.filter(item => item.type === 'folder');
			const files = linkedItems.filter(item => item.type === 'file');
			if (folders.length) payload.folder_ids = folders.map(f => f.id).join(',');
			if (files.length) payload.file_ids = files.map(f => f.id).join(',');
			await globalPutService(`camo/amp/${id}/document-checklists/`, payload);
		}
		if (currentData?.folder_uuid?.length > 0) {
			const formData = new FormData();
			formData.append('folder_uuid', currentData.folder_uuid);
			checklist.filter(item => item instanceof File).forEach(file => formData.append('files[]', file));
			await globalPutService(`camo/amp/${id}/document-checklists/`, formData);
		}
	};

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		const validationInputs = validate();
		if (!Object.values(validationInputs).every(v => v === "")) {
			setError(validationInputs);
			trackActivity(modeType === 'edit' ? 'AMP Updated Failed - CAMO' : 'AMP Data Added Failed - CAMO', {
				event_type: modeType === 'edit' ? 'Update Data Failed' : 'Add Data Failed',
				page_title: 'AMP Compliance',
				error_source: 'Frontend',
				error_type: validationInputs,
			});
			return;
		}
		const payload = {
			...data,
			threshold_D: data.threshold_D || null,
			threshold_FH: data.threshold_FH || null,
			threshold_FC: data.threshold_FC || null,
			interval_FH: data.interval_FH || null,
			interval_FC: data.interval_FC || null,
			interval_D: data.interval_D || null,
			lastDone_D: data.lastDone_D || null,
			lastDone_FC: data.lastDone_FC || null,
			lastDone_FH: data.lastDone_FH || null,
			nextDue_D: data.nextDue_D || null,
			nextDue_FH: data.nextDue_FH || null,
			nextDue_FC: data.nextDue_FC || null,
			remainingValues_D: data.remainingValues_D || null,
		};
		setIsLoading(true);
		if (modeType === 'edit') {
			globalPutService(`camo/amp/${ampData.id}/update/`, payload).then(async (response) => {
				if (checkApiStatus(response)) {
					await uploadFiles(ampData.id);
					enqueueSnackbar("Record Updated Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity('AMP Updated Successfully - CAMO', {
						event_type: 'Data Updated Successfully',
						page_title: 'AMP Compliance',
						item_id: ampData.id,
						request_body: payload,
					});
					setIsLoading(false);
					getResponseBack();
					modalCloseFn();
				} else {
					setIsLoading(false);
					enqueueSnackbar(response?.data?.message || "Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
		} else {
			if (!permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "C" })) {
				setIsLoading(false);
				return;
			}
			const createPayload = {
				...payload,
				asset_id: match.params.asset,
				asset_type_id: match.params.assetType,
			};
			globalPostService('camo/amp/create/', createPayload).then(async (response) => {
				if (checkApiStatus(response)) {
					const newId = response.data.data.id;
					await uploadFiles(newId);
					await submitFileLinks(newId);
					enqueueSnackbar(response.data.message || "Record Added Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity('AMP Data Added Successfully - CAMO', {
						event_type: 'Data Added Successfully',
						page_title: 'AMP Compliance',
						item_id: newId,
						request_body: createPayload,
					});
					setIsLoading(false);
					getResponseBack();
					if (addAnotherRef.current) {
						setData(formValues);
						setAttachments([]);
						setNewUploadedAttachments([]);
					} else {
						modalCloseFn();
					}
				} else {
					setIsLoading(false);
					enqueueSnackbar(response?.data?.message || "Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
		}
	};

	const onUpload = (files) => {
		const validFiles = Array.from(files).filter((file) => {
			if (file.size > 52428800) {
				enqueueSnackbar(`${file.name} Maximum file size should be 50MB.`, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				return false;
			}
			return true;
		});
		if (!validFiles.length) return;
		const newEntries = validFiles.map((file) => ({
			id: 0, module_id: 0, module_type_id: 1,
			file_name: file.name, file_type: file.type,
			file: "upload file", name: file.name,
			asset_id: match.params.asset,
			asset_type_id: match.params.assetType,
		}));
		setNewUploadedAttachments(prev => [...prev, ...validFiles]);
		setAttachments(prev => [...prev, ...newEntries]);
	};

	const handleDeleteAttachment = (id, attachment) => {
		if (id && id !== 0) {
			globalDeleteService(`camo/attachment/${id}/delete/`).then((response) => {
				if (checkApiStatus(response)) {
					enqueueSnackbar("Attachment Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					setAttachments(prev => prev.filter(item => item.id !== id));
					trackActivity("CAMO", { event_type: "Attachment Deleted", page_title: "AMP Compliance", item_id: id });
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
		} else {
			setAttachments(prev => prev.filter(item => item.file_name !== attachment?.file_name));
		}
		setDeleteAttachModal({ open: false, id: null, attachment: null });
	};

	const onUnlinkCheckListFile = (checklist, fileId) => {
		const payload = {
			delete: true,
			folder_ids: checklist?.folders?.filter(i => i.type === 'folder').map(f => f.id).filter(id => id !== fileId).join(','),
			file_ids: checklist?.files?.filter(i => i.type === 'file').map(f => f.id).filter(id => id !== fileId).join(','),
		};
		globalPutService(`camo/amp/${ampData.id}/document-checklists/`, payload).then((response) => {
			if (checkApiStatus(response)) {
				setData(prev => ({
					...prev,
					checklist: {
						...prev.checklist,
						files: prev.checklist.files?.filter(f => f.id !== fileId) || [],
						folders: prev.checklist.folders?.filter(f => f.id !== fileId) || [],
					},
				}));
			}
		});
	};

	const onLinkFile = (file, uuidVal, type) => {
		if (type === "link" || uuidVal) {
			setData(prev => {
				const incoming = [].concat(file);
				const prevChecklist = prev?.checklist;
				const existingFiles = Array.isArray(prevChecklist?.files) ? prevChecklist.files : [];
				const existingFolders = Array.isArray(prevChecklist?.folders) ? prevChecklist.folders : [];
				return {
					...prev,
					checklist: {
						...(!Array.isArray(prevChecklist) ? prevChecklist : {}),
						files: [...existingFiles, ...incoming.filter(f => f.type === 'file')],
						folders: [...existingFolders, ...incoming.filter(f => f.type === 'folder')],
					},
					folder_uuid: [...(prev?.folder_uuid ? [prev?.folder_uuid] : []), uuidVal].flat().join(""),
				};
			});
		} else {
			onUpload(file);
		}
	};

	const getResponseBackLocal = (file) => setData(prev => ({ ...prev, checklist: file }));
	const listResponseBack = (file) => { if (modeType === 'edit') getResponseBack(file); };

	const nextDueValue = () => {
		try {
			const lastDone = data?.lastDone_D ? new Date(data.lastDone_D) : null;
			const dom = date_of_manufacture ? new Date(date_of_manufacture) : null;
			const interval = parseInt(data?.interval_D) || 0;
			const threshold = parseInt(data?.threshold_D) || 0;
			let nextDue = null;
			if (lastDone && interval) {
				const d = new Date(lastDone);
				d.setDate(d.getDate() + interval);
				nextDue = moment(d).format(backendDateFormat);
			} else if (dom && threshold) {
				const d = new Date(dom);
				d.setDate(d.getDate() + threshold);
				nextDue = moment(d).format(backendDateFormat);
			}
			data.nextDue_D = nextDue;
			return moment(nextDue).isValid() ? nextDue : null;
		} catch { return null; }
	};

	const nextDueFHValue = () => {
		if (data.lastDone_FH > 0 && data.interval_FH > 0) {
			data.nextDue_FH = data.lastDone_FH === '' ? null : (+data.lastDone_FH + +data.interval_FH).toFixed(0);
		} else {
			data.nextDue_FH = data.threshold_FH?.length > 0 ? (+data.threshold_FH + +headerTsn).toFixed(0) : '';
		}
		return data.nextDue_FH;
	};

	const nextDueFCValue = () => {
		if (data.lastDone_FC > 0 && data.interval_FC > 0) {
			data.nextDue_FC = (data.lastDone_FC === '' || data.lastDone_FC === null) ? null : (+data.lastDone_FC + +data.interval_FC).toFixed(0);
		} else {
			data.nextDue_FC = data.threshold_FC?.length > 0 ? (+data.threshold_FC + +headerCsn).toFixed(0) : '';
		}
		return data.nextDue_FC;
	};

	const remainingDaysValues = () => {
		const lDate = moment(data.nextDue_D);
		if (data?.nextDue_D && lDate.isValid()) {
			data.remainingValues_D = lDate.diff(moment().startOf("day"), "days");
		} else {
			data.remainingValues_D = null;
		}
		return data.remainingValues_D ?? null;
	};

	const remainingFHValues = () => {
		if (headerTsn && data.interval_FH > 0 && data.lastDone_FH && parseInt(data.lastDone_FH) + parseInt(data.interval_FH) > 0) {
			const diff = data.nextDue_FH !== 0 ? data.nextDue_FH - headerTsn : null;
			data.remainingValues_FH = diff !== null ? (Number.isInteger(diff) ? diff : parseFloat(diff.toFixed(2))) : "";
		} else {
			data.remainingValues_FH = "";
		}
		return data.remainingValues_FH ?? "";
	};

	const remainingFCValues = () => {
		if (headerCsn && data.interval_FC > 0 && data.lastDone_FC && parseInt(data.lastDone_FC) + parseInt(data.interval_FC) > 0) {
			const diff = data.nextDue_FC - headerCsn;
			data.remainingValues_FC = parseFloat(diff.toFixed(Number.isInteger(diff) ? 0 : 2));
		} else {
			data.remainingValues_FC = "";
		}
		return data.remainingValues_FC ?? "";
	};

	const numericFieldProps = (key, maxLen) => ({
		onChange: (e) => {
			const input = e.target.value;
			if (input.length <= maxLen && regexConstants.onlyNumeric.test(input)) {
				onFieldChange(key, input);
				onRestErrorKey(key);
			} else if (input.length > maxLen && regexConstants.onlyNumeric.test(input)) {
				onFieldChange(key, input.slice(0, maxLen));
				onRestErrorKey(key);
			} else {
				e.preventDefault();
			}
		},
	});

	return (
		<Fragment>
			{isLoading ? <PageLoader /> : null}
			<Dialog open={true} maxWidth="lg" fullWidth>
				<div className="amp-form">
					<DialogTitle className="amp-form__title">
						{modeType === 'edit' ? "Update AMP/MRB Compliance" : "AMP/MRB Compliance"}
						<CloseIcon onClick={modalCloseFn} className="amp-form__close-icon" />
					</DialogTitle>
					<DialogContent>
						<Grid spacing={1} container>
							<Grid item md={4} sm={6} xs={12}>
								<TextField
									variant="outlined"
									required
									label="MPD Item Number"
									name="MPD_item_no"
									id="MPD_item_no"
									value={data?.MPD_item_no || ''}
									error={!!error.MPD_item_no}
									helperText={error.MPD_item_no || ""}
									inputProps={{ maxLength: 20 }}
									onChange={(e) => onFieldChange("MPD_item_no", e.target.value)}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("MPD_item_no")}
								/>
							</Grid>
							<Grid item md={4} sm={6} xs={12}>
								<TextField
									required={!acumenCamo}
									variant="outlined"
									label="Task Card Number"
									name="task_card_no"
									id="task_card_no"
									value={data.task_card_no || ''}
									error={!!error.task_card_no}
									inputProps={{ maxLength: 20 }}
									helperText={error.task_card_no || ""}
									onChange={(e) => onFieldChange("task_card_no", e.target.value)}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("task_card_no")}
								/>
							</Grid>
							<Grid item md={4} sm={6} xs={12}>
								<TextField
									variant="outlined"
									label="Previous LDND Task Number"
									name="previous_LDND_Taskcard"
									id="previous_LDND_Taskcard"
									inputProps={{ maxLength: 20 }}
									value={data.previous_LDND_Taskcard || ""}
									onChange={(e) => onFieldChange("previous_LDND_Taskcard", e.target.value)}
									InputLabelProps={{ shrink: true }}
								/>
							</Grid>
							<Grid item md={12} sm={6} xs={12}>
								<TextField
									required={!acumenCamo}
									variant="outlined"
									label="Task Description"
									name="Task_Description"
									id="Task_Description"
									multiline
									error={!!error?.Task_Description}
									helperText={error?.Task_Description || ""}
									value={data?.Task_Description || ""}
									inputProps={{ maxLength: 255 }}
									onChange={(e) => onFieldChange("Task_Description", e.target.value)}
									InputLabelProps={{ shrink: true }}
									onFocus={() => onRestErrorKey("Task_Description")}
								/>
							</Grid>
						</Grid>
						<div className="amp-form__divider" />
						<Grid spacing={1} container>
							<Grid item md={4} sm={12} xs={12}>
								<label className="amp-form__section-label">THRESHOLD</label>
								<Grid spacing={1} container>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											required={acumenCamo ? false : (!data.threshold_FH && !data.threshold_FC)}
											label="Days"
											name="threshold_D"
											id="threshold_D"
											error={!!error.threshold_D}
											helperText={acumenCamo ? '' : error.threshold_D || ""}
											value={data.threshold_D ?? ""}
											{...numericFieldProps("threshold_D", 5)}
											onFocus={() => onRestErrorKey("threshold_D")}
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FH"
											name="threshold_FH"
											id="threshold_FH"
											error={!!error.threshold_FH}
											helperText={error.threshold_FH || ""}
											value={data.threshold_FH ?? ""}
											{...numericFieldProps("threshold_FH", 10)}
											onFocus={() => onRestErrorKey("threshold_FH")}
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FC"
											name="threshold_FC"
											id="threshold_FC"
											error={!!error.threshold_FC}
											helperText={error.threshold_FC || ""}
											value={data.threshold_FC ?? ""}
											{...numericFieldProps("threshold_FC", 10)}
											onFocus={() => onRestErrorKey("threshold_FC")}
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item md={4} sm={12} xs={12}>
								<label className="amp-form__section-label">INTERVAL</label>
								<Grid spacing={1} container>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											required={acumenCamo ? false : (data.threshold_D !== undefined && data.threshold_D !== null && data.threshold_D !== "")}
											variant="outlined"
											label="Days"
											name="interval_D"
											id="interval_D"
											error={!!error.interval_D}
											helperText={error.interval_D || ""}
											value={data.interval_D ?? ""}
											{...numericFieldProps("interval_D", 5)}
											InputLabelProps={{ shrink: true }}
											onFocus={() => onRestErrorKey("interval_D")}
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											required={acumenCamo ? false : (data.threshold_FH !== undefined && data.threshold_FH !== null && data.threshold_FH !== "")}
											label="FH"
											name="interval_FH"
											id="interval_FH"
											error={!!error.interval_FH}
											helperText={error.interval_FH || ""}
											value={data.interval_FH ?? ""}
											{...numericFieldProps("interval_FH", 10)}
											InputLabelProps={{ shrink: true }}
											onFocus={() => onRestErrorKey("interval_FH")}
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											required={acumenCamo ? false : (data.threshold_FC !== undefined && data.threshold_FC !== null && data.threshold_FC !== "")}
											label="FC"
											name="interval_FC"
											id="interval_FC"
											error={!!error.interval_FC}
											helperText={error.interval_FC || ""}
											value={data.interval_FC ?? ""}
											{...numericFieldProps("interval_FC", 10)}
											InputLabelProps={{ shrink: true }}
											onFocus={() => onRestErrorKey("interval_FC")}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item md={4} sm={12} xs={12}>
								<label className="amp-form__section-label">LAST DONE</label>
								<Grid spacing={1} container>
									<Grid item md={4} sm={4} xs={12} className="input-calender">
										<MuiPickersUtilsProvider utils={MomentUtils}>
											<KeyboardDatePicker
												id="lastDone_D"
												required={acumenCamo ? false : (data.threshold_D !== undefined && data.threshold_D !== null && data.threshold_D !== "")}
												label="Date"
												format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
												inputVariant="outlined"
												fullWidth
												disableFuture
												InputLabelProps={{ shrink: true }}
												minDate={moment().subtract(25, "years")}
												value={data.lastDone_D || ''}
												error={!!error.lastDone_D}
												helperText={acumenCamo ? '' : error.lastDone_D || ""}
												onChange={(val) => onFieldChange("lastDone_D", moment(val).isValid() ? moment(val).format(backendDateFormat) : null)}
											/>
										</MuiPickersUtilsProvider>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											required={acumenCamo ? false : (data.threshold_FH !== undefined && data.threshold_FH !== null && data.threshold_FH !== "")}
											label="FH"
											name="lastDone_FH"
											id="lastDone_FH"
											InputLabelProps={{ shrink: true }}
											error={!!error.lastDone_FH}
											helperText={error.lastDone_FH || ""}
											value={data.lastDone_FH || ""}
											{...numericFieldProps("lastDone_FH", 10)}
											onFocus={() => onRestErrorKey("lastDone_FH")}
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											required={acumenCamo ? false : (data.threshold_FC !== undefined && data.threshold_FC !== null && data.threshold_FC !== "")}
											label="FC"
											name="lastDone_FC"
											id="lastDone_FC"
											InputLabelProps={{ shrink: true }}
											error={!!error.lastDone_FC}
											helperText={error.lastDone_FC || ""}
											value={data.lastDone_FC || ""}
											{...numericFieldProps("lastDone_FC", 10)}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid spacing={1} container>
							<Grid item md={6} sm={12} xs={12}>
								<label className="amp-form__section-label">NEXT DUE</label>
								<Grid spacing={1} container>
									<Grid item md={4} sm={4} xs={12} className="input-calender" id="disabled">
										<MuiPickersUtilsProvider utils={MomentUtils}>
											<KeyboardDatePicker
												id="date_of_manufacture"
												format={acumenCamo ? fieldDMYShort : dayMonthDateFormat}
												inputVariant="outlined"
												label="Date"
												fullWidth
												disableFuture
												disabled
												InputLabelProps={{ shrink: true }}
												minDate={moment().subtract(25, "years")}
												value={nextDueValue() || null}
												error={!!error.nextDue_D}
												helperText={error.nextDue_D || ""}
												onFocus={() => onRestErrorKey("nextDue_D")}
												onChange={(val) => onFieldChange("nextDue_D", moment(val).isValid() ? moment(val).format(backendDateFormat) : null)}
												className="amp-form__disabled-input"
											/>
										</MuiPickersUtilsProvider>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FH"
											name="nextDue_FH"
											id="nextDue_FH"
											value={nextDueFHValue()}
											inputProps={{ readOnly: true }}
											InputLabelProps={{ shrink: true }}
											disabled
											className="amp-form__disabled-input"
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FC"
											name="nextDue_FC"
											id="nextDue_FC"
											value={nextDueFCValue()}
											inputProps={{ readOnly: true }}
											InputLabelProps={{ shrink: true }}
											disabled
											className="amp-form__disabled-input"
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item md={6} sm={12} xs={12}>
								<label className="amp-form__section-label">REMAINING</label>
								<Grid spacing={1} container>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="Days"
											name="remainingValues_D"
											id="remainingValues_D"
											value={remainingDaysValues() ?? ""}
											InputLabelProps={{ shrink: true }}
											inputProps={{ readOnly: true }}
											disabled
											className="amp-form__disabled-input"
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FH"
											name="remainingValues_FH"
											id="remainingValues_FH"
											InputLabelProps={{ shrink: true }}
											value={remainingFHValues() ?? ""}
											inputProps={{ readOnly: true }}
											disabled
											className="amp-form__disabled-input"
										/>
									</Grid>
									<Grid item md={4} sm={4} xs={12}>
										<TextField
											variant="outlined"
											label="FC"
											name="remainingValues_FC"
											id="remainingValues_FC"
											InputLabelProps={{ shrink: true }}
											value={remainingFCValues() ?? ""}
											inputProps={{ readOnly: true }}
											disabled
											className="amp-form__disabled-input"
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<div className="amp-form__divider" />
						<Grid spacing={1} container>
							<Grid item md={12} sm={6} xs={12}>
								<TextField
									label="Remarks"
									margin="normal"
									variant="outlined"
									fullWidth
									value={data.remarks || ''}
									InputLabelProps={{ shrink: true }}
									onChange={(e) => onFieldChange("remarks", e.target.value)}
									rows={3}
									multiline
									inputProps={{ maxLength: 255 }}
								/>
							</Grid>
							<Grid item md={6} sm={6} xs={12}>
								<TextField
									label="WorkOrder Reference"
									margin="normal"
									variant="outlined"
									fullWidth
									name="workOrder"
									id="workOrder"
									value={data?.workOrder || ''}
									InputLabelProps={{ shrink: true }}
									onChange={(e) => onFieldChange("workOrder", e.target.value)}
									rows={3}
									multiline
									inputProps={{ maxLength: 255 }}
								/>
							</Grid>
							<Grid item md={6} sm={6} xs={12}>
								<div className="amp-form__file-upload-box">
									<ul className="list-inline amp-form__upload-list">
										<li className="list-inline-item" onClick={() => setUploadFile(true)}>
											<span className="flex-centered">
												<AttachmentIcon color="primary" fontSize="small" /> Upload File
											</span>
										</li>
										<li className="list-inline-item" onClick={() => setLinkFile(true)}>
											<span className="flex-centered">
												<LinkIcon color="primary" fontSize="small" /> Link file from Records Module
											</span>
										</li>
									</ul>
								</div>
							</Grid>
						</Grid>
						<Grid spacing={1} container>
							<Grid spacing={1} container>
								{modeType !== 'edit' ? (
									<div className="amp-form__file-list">
										<ul className="list-inline">
											{data?.checklist?.map((file, idx) => (
												<li key={idx} className="list-inline-item">
													<span className="amp-form__file-name">{file.name}</span>
													<span className="amp-form__file-remove">
														<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => setData(prev => ({ ...prev, checklist: prev.checklist.filter(item => item.name !== file.name) }))} color="secondary" fontSize="small" />
													</span>
												</li>
											))}
											{attachments.map((attachment, idx) => (
												<li key={idx} className="list-inline-item">
													<span className="amp-form__file-name">{attachment.file_name}</span>
													<span className="amp-form__file-remove">
														<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => setAttachments(prev => prev.filter(item => item.file_name !== attachment.file_name))} color="secondary" fontSize="small" />
													</span>
												</li>
											))}
										</ul>
									</div>
								) : (
									<div className="amp-form__file-list">
										<ul className="list-inline">
											{data?.checklist?.files?.map((file, idx) => (
												<li key={idx} className="list-inline-item">
													<span className="amp-form__file-name">{file.name}</span>
													<span className="amp-form__file-remove">
														<a href={decodeURIComponent(file.path)} download={file.name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color="secondary" fontSize="small" />
													</span>
												</li>
											))}
											{data.checklist?.folders?.map((file) => (
												<li className="list-inline-item" key={file.id}>
													<Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
														<a href={`${config.domain.records}${assetType[match?.params?.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new">
															<img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records Data Room" />
														</a>
													</Tooltip>
													<span className="amp-form__file-name">{file.name}</span>
													<span className="amp-form__file-remove">
														<CloseIcon onClick={() => onUnlinkCheckListFile(data.checklist, file.id)} color="secondary" fontSize="small" />
													</span>
												</li>
											))}
											{attachments?.map((attachment, idx) => (
												<li key={idx} className="list-inline-item">
													<span className="amp-form__file-name">{attachment.file_name}</span>
													<span className="amp-form__file-remove">
														<a href={decodeURIComponent(attachment.file)} download={attachment.file_name}><GetAppIcon color="primary" /></a>
														<CloseIcon onClick={() => setDeleteAttachModal({ open: true, id: attachment.id, attachment })} color="secondary" fontSize="small" />
													</span>
												</li>
											))}
										</ul>
									</div>
								)}
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions className="amp-form__actions">
						<Button type="button" className="btn btn-primary" disabled={isLoading} onClick={(e) => { addAnotherRef.current = false; handleFormSubmit(e); }}>
							{modeType === 'edit' ? "Update" : "Add"}
						</Button>
						{modeType !== 'edit' && (
							<Button type="button" className="btn btn-primary" disabled={isLoading} onClick={(e) => { addAnotherRef.current = true; handleFormSubmit(e); }}>
								Save &amp; Add Another
							</Button>
						)}
						<Button type="button" className="btn btn-primary" onClick={modalCloseFn}>Close</Button>
					</DialogActions>
				</div>
			</Dialog>
			{deleteAttachModal.open && (
				<DeletePopUp
					modal={deleteAttachModal.open}
					title="Delete Attachment"
					content="Do you really want to delete the selected Attachment?"
					toggleModalFn={() => setDeleteAttachModal({ open: false, id: null, attachment: null })}
					deleteRecordFn={() => handleDeleteAttachment(deleteAttachModal.id, deleteAttachModal.attachment)}
				/>
			)}
			<Dialog open={linkFile} onClose={() => setLinkFile(false)} id="htDialog">
				<LinkFiles
					handleClose={() => setLinkFile(false)}
					uuid={uuid?.uuid}
					editFormId={modeType === 'edit' ? ampData?.id : null}
					getResponseBack={(file) => getResponseBackLocal(file)}
					listResponseBack={(file) => listResponseBack(file)}
					onLinkFile={(file, any, type) => onLinkFile(file, any, type)}
					modType="amp"
					last_used_folder_uuid={last_used_folder_uuid_link_document}
					uploadFileInfo={data}
					attachments={attachments}
					type="link"
					actionType='add'
				/>
			</Dialog>
			<Dialog open={uploadFile} onClose={() => setUploadFile(false)} id="htDialog">
				<UploadFile
					handleClose={() => setUploadFile(false)}
					uuid={uuid?.uuid}
					editFormId={modeType === 'edit' ? ampData?.id : null}
					getResponseBack={(file) => getResponseBackLocal(file)}
					listResponseBack={(file) => listResponseBack(file)}
					onLinkFile={(file, uuidVal) => onLinkFile(file, uuidVal)}
					modType="amp"
					uploadFileInfo={data}
					last_used_folder_uuid={last_used_folder_uuid}
					onUpload={(file) => onUpload(file)}
					type="upload"
					checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
					checkbox_last_used_folder_name={checkbox_last_used_folder_name}
					actionType='add'
				/>
			</Dialog>
		</Fragment>
	);
};

export default withRouter(AmpTaskForm);
